export const bg_accent = "#B6FF80";
export const bg_accent_emphasis = "#003F2E";
export const bg_accent_emphasis_hover = "#054F3E";
export const bg_accent_emphasis_hover_hover = "#054F3E";
export const bg_accent_emphasis_hover_pressed = "#054F3E";
export const bg_accent_emphasis_pressed = "#056049";
export const bg_accent_emphasis_pressed_hover = "#054F3E";
export const bg_accent_emphasis_pressed_pressed = "#054F3E";
export const bg_accent_emphasis_selected = "#056049";
export const bg_accent_emphasis_selected_hover = "#054F3E";
export const bg_accent_emphasis_selected_pressed = "#054F3E";
export const bg_accent_inset = "#ff00ff";
export const bg_brand = "#ECFDF3";
export const bg_brand_emphasis = "#039861";
export const bg_brand_emphasis_hover = "#12B778";
export const bg_brand_emphasis_pressed = "#056049";
export const bg_brand_hover = "#D1FADF";
export const bg_brand_inset = "#D1FADF";
export const bg_brand_inset_hover = "#A6F4C5";
export const bg_brand_inset_pressed = "#6CE9A6";
export const bg_brand_pressed = "#A6F4C5";
export const bg_busy = "#EEF4FF";
export const bg_busy_emphasis = "#444CE7";
export const bg_busy_emphasis_hover = "#6172F3";
export const bg_busy_emphasis_pressed = "#2D31A6";
export const bg_busy_hover = "#E0EAFF";
export const bg_busy_inset = "#E0EAFF";
export const bg_busy_inset_hover = "#C7D7FE";
export const bg_busy_inset_pressed = "#A4BCFD";
export const bg_busy_pressed = "#C7D7FE";
export const bg_default = "#fff";
export const bg_default_hover = "#F1F1F1";
export const bg_default_pressed = "#E8E8E8";
export const bg_destructive = "#FEF3F2";
export const bg_destructive_emphasis = "#D92D20";
export const bg_destructive_emphasis_hover = "#F04438";
export const bg_destructive_emphasis_pressed = "#912018";
export const bg_destructive_hover = "#FEE4E2";
export const bg_destructive_inset = "#FEE4E2";
export const bg_destructive_inset_hover = "#FECDCA";
export const bg_destructive_inset_pressed = "#FDA29B";
export const bg_destructive_pressed = "#FECDCA";
export const bg_emphasis = "#2B2B2B";
export const bg_emphasis_hover = "#454545";
export const bg_emphasis_pressed = "#1C1C1C";
export const bg_focustime = "#ECFDF3";
export const bg_focustime_emphasis = "#039861";
export const bg_focustime_emphasis_hover = "#12B778";
export const bg_focustime_emphasis_pressed = "#056049";
export const bg_focustime_hover = "#D1FADF";
export const bg_focustime_inset = "#D1FADF";
export const bg_focustime_inset_hover = "#A6F4C5";
export const bg_focustime_inset_pressed = "#6CE9A6";
export const bg_focustime_pressed = "#A6F4C5";
export const bg_fragmented = "#FFFAEB";
export const bg_fragmented_emphasis = "#FDB022";
export const bg_fragmented_emphasis_hover = "#FEC84B";
export const bg_fragmented_emphasis_pressed = "#DC6803";
export const bg_fragmented_hover = "#FEF0C7";
export const bg_fragmented_inset = "#FEF0C7";
export const bg_fragmented_inset_hover = "#FEDF89";
export const bg_fragmented_inset_pressed = "#FEC84B";
export const bg_fragmented_pressed = "#FEDF89";
export const bg_info = "#F0FBFF";
export const bg_info_emphasis = "#0097C9";
export const bg_info_emphasis_hover = "#0BB7EC";
export const bg_info_emphasis_pressed = "#066486";
export const bg_info_hover = "#E0FAFE";
export const bg_info_inset = "#E0FAFE";
export const bg_info_inset_hover = "#B9F1FE";
export const bg_info_inset_pressed = "#7CDFFD";
export const bg_info_pressed = "#B9F1FE";
export const bg_neutral = "#FAFAFA";
export const bg_neutral_emphasis = "#2B2B2B";
export const bg_neutral_emphasis_hover = "#454545";
export const bg_neutral_emphasis_pressed = "#1C1C1C";
export const bg_neutral_hover = "#F1F1F1";
export const bg_neutral_inset = "#F1F1F1";
export const bg_neutral_inset_hover = "#E8E8E8";
export const bg_neutral_inset_pressed = "#D6D6D6";
export const bg_neutral_pressed = "#E8E8E8";
export const bg_positive = "#ECFDF3";
export const bg_positive_emphasis = "#039861";
export const bg_positive_emphasis_hover = "#12B778";
export const bg_positive_emphasis_pressed = "#056049";
export const bg_positive_hover = "#D1FADF";
export const bg_positive_inset = "#D1FADF";
export const bg_positive_inset_hover = "#A6F4C5";
export const bg_positive_inset_pressed = "#6CE9A6";
export const bg_positive_pressed = "#A6F4C5";
export const bg_underlay = "#FCFCFC";
export const bg_underlay_hover = "#F1F1F1";
export const bg_underlay_pressed = "#E8E8E8";
export const bg_warning = "#FFFAEB";
export const bg_warning_emphasis = "#DC6803";
export const bg_warning_emphasis_hover = "#F79009";
export const bg_warning_emphasis_pressed = "#93370D";
export const bg_warning_hover = "#FEF0C7";
export const bg_warning_inset = "#FEF0C7";
export const bg_warning_inset_hover = "#FEDF89";
export const bg_warning_inset_pressed = "#FEC84B";
export const bg_warning_pressed = "#FEDF89";
export const border_accent = "#B6FF80";
export const border_accent_emphasis = "#003F2E";
export const border_accent_interactable = "#ff00ff";
export const border_accent_muted = "#ff00ff";
export const border_brand = "#6CE9A6";
export const border_brand_emphasis = "#027A52";
export const border_brand_emphasis_hover = "#039861";
export const border_brand_emphasis_pressed = "#054F3E";
export const border_brand_hover = "#32D591";
export const border_brand_interactable = "#32D591";
export const border_brand_interactable_hover = "#12B778";
export const border_brand_interactable_pressed = "#039861";
export const border_brand_muted = "#A6F4C5";
export const border_brand_muted_hover = "#6CE9A6";
export const border_brand_muted_pressed = "#32D591";
export const border_brand_pressed = "#12B778";
export const border_busy = "#A4BCFD";
export const border_busy_emphasis = "#3538CD";
export const border_busy_emphasis_hover = "#444CE7";
export const border_busy_emphasis_pressed = "#2D3282";
export const border_busy_hover = "#8098F9";
export const border_busy_interactable = "#8098F9";
export const border_busy_interactable_hover = "#6172F3";
export const border_busy_interactable_pressed = "#444CE7";
export const border_busy_muted = "#C7D7FE";
export const border_busy_muted_hover = "#A4BCFD";
export const border_busy_muted_pressed = "#8098F9";
export const border_busy_pressed = "#6172F3";
export const border_default = "#D6D6D6";
export const border_default_hover = "#A6A6A6";
export const border_default_pressed = "#757575";
export const border_destructive = "#FDA29B";
export const border_destructive_emphasis = "#B42318";
export const border_destructive_emphasis_hover = "#D92D20";
export const border_destructive_emphasis_pressed = "#7A271A";
export const border_destructive_hover = "#F97066";
export const border_destructive_interactable = "#F97066";
export const border_destructive_interactable_hover = "#F04438";
export const border_destructive_interactable_pressed = "#D92D20";
export const border_destructive_muted = "#FECDCA";
export const border_destructive_muted_hover = "#FDA29B";
export const border_destructive_muted_pressed = "#F97066";
export const border_destructive_pressed = "#F04438";
export const border_emphasis = "#454545";
export const border_emphasis_hover = "#575757";
export const border_emphasis_pressed = "#1C1C1C";
export const border_focustime = "#6CE9A6";
export const border_focustime_emphasis = "#027A52";
export const border_focustime_emphasis_hover = "#039861";
export const border_focustime_emphasis_pressed = "#054F3E";
export const border_focustime_hover = "#32D591";
export const border_focustime_interactable = "#32D591";
export const border_focustime_interactable_hover = "#12B778";
export const border_focustime_interactable_pressed = "#039861";
export const border_focustime_muted = "#A6F4C5";
export const border_focustime_muted_hover = "#6CE9A6";
export const border_focustime_muted_pressed = "#32D591";
export const border_focustime_pressed = "#12B778";
export const border_fragmented = "#FEC84B";
export const border_fragmented_emphasis = "#B54708";
export const border_fragmented_emphasis_hover = "#DC6803";
export const border_fragmented_emphasis_pressed = "#7A2E0E";
export const border_fragmented_hover = "#FDB022";
export const border_fragmented_interactable = "#F79009";
export const border_fragmented_interactable_hover = "#DC6803";
export const border_fragmented_interactable_pressed = "#B54708";
export const border_fragmented_muted = "#FEDF89";
export const border_fragmented_muted_hover = "#FEC84B";
export const border_fragmented_muted_pressed = "#FDB022";
export const border_fragmented_pressed = "#F79009";
export const border_info = "#7CDFFD";
export const border_info_emphasis = "#0278A2";
export const border_info_emphasis_hover = "#0097C9";
export const border_info_emphasis_pressed = "#0B536F";
export const border_info_hover = "#36CFFA";
export const border_info_interactable = "#36CFFA";
export const border_info_interactable_hover = "#0BB7EC";
export const border_info_interactable_pressed = "#0097C9";
export const border_info_muted = "#B9F1FE";
export const border_info_muted_hover = "#7CDFFD";
export const border_info_muted_pressed = "#36CFFA";
export const border_info_pressed = "#0BB7EC";
export const border_interactable = "#A6A6A6";
export const border_interactable_hover = "#757575";
export const border_interactable_pressed = "#575757";
export const border_muted = "#E8E8E8";
export const border_muted_hover = "#D6D6D6";
export const border_muted_pressed = "#A6A6A6";
export const border_neutral = "#D6D6D6";
export const border_neutral_emphasis = "#454545";
export const border_neutral_emphasis_hover = "#575757";
export const border_neutral_emphasis_pressed = "#1C1C1C";
export const border_neutral_hover = "#A6A6A6";
export const border_neutral_interactable = "#A6A6A6";
export const border_neutral_interactable_hover = "#757575";
export const border_neutral_interactable_pressed = "#575757";
export const border_neutral_muted = "#E8E8E8";
export const border_neutral_muted_hover = "#D6D6D6";
export const border_neutral_muted_pressed = "#A6A6A6";
export const border_neutral_pressed = "#757575";
export const border_positive = "#6CE9A6";
export const border_positive_emphasis = "#027A52";
export const border_positive_emphasis_hover = "#039861";
export const border_positive_emphasis_pressed = "#054F3E";
export const border_positive_hover = "#32D591";
export const border_positive_interactable = "#32D591";
export const border_positive_interactable_hover = "#12B778";
export const border_positive_interactable_pressed = "#039861";
export const border_positive_muted = "#A6F4C5";
export const border_positive_muted_hover = "#6CE9A6";
export const border_positive_muted_pressed = "#32D591";
export const border_positive_pressed = "#12B778";
export const border_subtle = "#F1F1F1";
export const border_subtle_hover = "#E8E8E8";
export const border_subtle_pressed = "#D6D6D6";
export const border_warning = "#FEC84B";
export const border_warning_emphasis = "#B54708";
export const border_warning_emphasis_hover = "#DC6803";
export const border_warning_emphasis_pressed = "#7A2E0E";
export const border_warning_hover = "#FDB022";
export const border_warning_interactable = "#FDB022";
export const border_warning_interactable_hover = "#F79009";
export const border_warning_interactable_pressed = "#DC6803";
export const border_warning_muted = "#FEDF89";
export const border_warning_muted_hover = "#FEC84B";
export const border_warning_muted_pressed = "#FDB022";
export const border_warning_pressed = "#F79009";
export const disabled_bg_ALLROLES = "#FAFAFA";
export const disabled_bg_ALLROLES_emphasis = "#A6A6A6";
export const disabled_bg_ALLROLES_inset = "#F1F1F1";
export const disabled_bg_default = "#FAFAFA";
export const disabled_bg_emphasis = "#A6A6A6";
export const disabled_border_ALLROLES = "#D6D6D6";
export const disabled_border_ALLROLES_emphasis = "#A6A6A6";
export const disabled_border_ALLROLES_interactable = "#D6D6D6";
export const disabled_border_ALLROLES_muted = "#D6D6D6";
export const disabled_border_default = "#D6D6D6";
export const disabled_border_emphasis = "#A6A6A6";
export const disabled_border_muted = "#D6D6D6";
export const disabled_border_subtle = "#D6D6D6";
export const disabled_fg_ALLROLES = "#A6A6A6";
export const disabled_fg_ALLROLES_muted = "#A6A6A6";
export const disabled_fg_default = "#A6A6A6";
export const disabled_fg_muted = "#A6A6A6";
export const disabled_fg_onEmphasis = "#F1F1F1";
export const disabled_fg_subtle = "#A6A6A6";
export const fg_accent = "#003F2E";
export const fg_accent_muted = "#ff00ff";
export const fg_accent_onEmphasis = "#B6FF80";
export const fg_brand = "#027A52";
export const fg_brand_hover = "#056049";
export const fg_brand_muted = "#039861";
export const fg_brand_muted_hover = "#027A52";
export const fg_brand_muted_pressed = "#056049";
export const fg_brand_pressed = "#054F3E";
export const fg_busy = "#444CE7";
export const fg_busy_hover = "#3538CD";
export const fg_busy_muted = "#8098F9";
export const fg_busy_muted_hover = "#6172F3";
export const fg_busy_muted_pressed = "#444CE7";
export const fg_busy_pressed = "#2D31A6";
export const fg_default = "#2B2B2B";
export const fg_default_hover = "#1C1C1C";
export const fg_default_pressed = "#1C1C1C";
export const fg_destructive = "#B42318";
export const fg_destructive_hover = "#912018";
export const fg_destructive_muted = "#D92D20";
export const fg_destructive_muted_hover = "#B42318";
export const fg_destructive_muted_pressed = "#912018";
export const fg_destructive_pressed = "#7A271A";
export const fg_focustime = "#027A52";
export const fg_focustime_hover = "#056049";
export const fg_focustime_muted = "#039861";
export const fg_focustime_muted_hover = "#027A52";
export const fg_focustime_muted_pressed = "#056049";
export const fg_focustime_pressed = "#054F3E";
export const fg_fragmented = "#DC6803";
export const fg_fragmented_hover = "#B54708";
export const fg_fragmented_muted = "#F79009";
export const fg_fragmented_muted_hover = "#DC6803";
export const fg_fragmented_muted_pressed = "#B54708";
export const fg_fragmented_pressed = "#93370D";
export const fg_info = "#0278A2";
export const fg_info_hover = "#066486";
export const fg_info_muted = "#0097C9";
export const fg_info_muted_hover = "#0278A2";
export const fg_info_muted_pressed = "#066486";
export const fg_info_pressed = "#0B536F";
export const fg_muted = "#575757";
export const fg_muted_hover = "#454545";
export const fg_muted_pressed = "#2B2B2B";
export const fg_neutral = "#2B2B2B";
export const fg_neutral_hover = "#1C1C1C";
export const fg_neutral_muted = "#575757";
export const fg_neutral_muted_hover = "#454545";
export const fg_neutral_muted_pressed = "#2B2B2B";
export const fg_neutral_pressed = "#1C1C1C";
export const fg_onEmphasis = "#fff";
export const fg_onEmphasis_hover = "#F1F1F1";
export const fg_onEmphasis_pressed = "#E8E8E8";
export const fg_positive = "#027A52";
export const fg_positive_hover = "#056049";
export const fg_positive_muted = "#039861";
export const fg_positive_muted_hover = "#027A52";
export const fg_positive_muted_pressed = "#056049";
export const fg_positive_pressed = "#054F3E";
export const fg_subtle = "#757575";
export const fg_subtle_hover = "#575757";
export const fg_subtle_pressed = "#454545";
export const fg_warning = "#B54708";
export const fg_warning_hover = "#93370D";
export const fg_warning_muted = "#DC6803";
export const fg_warning_muted_hover = "#B54708";
export const fg_warning_muted_pressed = "#93370D";
export const fg_warning_pressed = "#7A2E0E";
export const palette = {"accent":{"one":"#003F2E"},"named":{"malachite":"#003F2E","pellegrino":"#00A972","lapis":"#4459DD","orange":"#FF7000","pink":"#FFE5FF","lime":"#B6FF80","shore":"#BBFDF4","lightblue":"#E2FFF9","lemon":"#FFE800","butter":"#FFFFBA","lightyellow":"#FFFFEC","beige":"#FDF9F7"},"neutral":{"25":"#FCFCFC","50":"#FAFAFA","100":"#F1F1F1","200":"#E8E8E8","300":"#D6D6D6","400":"#A6A6A6","500":"#757575","600":"#575757","700":"#454545","800":"#2B2B2B","900":"#1C1C1C"},"warning":{"25":"#FFFCF5","50":"#FFFAEB","100":"#FEF0C7","200":"#FEDF89","300":"#FEC84B","400":"#FDB022","500":"#F79009","600":"#DC6803","700":"#B54708","800":"#93370D","900":"#7A2E0E"},"positive":{"25":"#F6FEF9","50":"#ECFDF3","100":"#D1FADF","200":"#A6F4C5","300":"#6CE9A6","400":"#32D591","500":"#12B778","600":"#039861","700":"#027A52","800":"#056049","900":"#054F3E"},"brand":{"25":"#F6FEF9","50":"#ECFDF3","100":"#D1FADF","200":"#A6F4C5","300":"#6CE9A6","400":"#32D591","500":"#12B778","600":"#039861","700":"#027A52","800":"#056049","900":"#054F3E"},"info":{"25":"#F5FBFF","50":"#F0FBFF","100":"#E0FAFE","200":"#B9F1FE","300":"#7CDFFD","400":"#36CFFA","500":"#0BB7EC","600":"#0097C9","700":"#0278A2","800":"#066486","900":"#0B536F"},"destructive":{"25":"#FFFBFA","50":"#FEF3F2","100":"#FEE4E2","200":"#FECDCA","300":"#FDA29B","400":"#F97066","500":"#F04438","600":"#D92D20","700":"#B42318","800":"#912018","900":"#7A271A"},"busy":{"25":"#F5F8FF","50":"#EEF4FF","100":"#E0EAFF","200":"#C7D7FE","300":"#A4BCFD","400":"#8098F9","500":"#6172F3","600":"#444CE7","700":"#3538CD","800":"#2D31A6","900":"#2D3282"},"focustime":{"25":"#F6FEF9","50":"#ECFDF3","100":"#D1FADF","200":"#A6F4C5","300":"#6CE9A6","400":"#32D591","500":"#12B778","600":"#039861","700":"#027A52","800":"#056049","900":"#054F3E"},"fragmented":{"25":"#FFFCF5","50":"#FFFAEB","100":"#FEF0C7","200":"#FEDF89","300":"#FEC84B","400":"#FDB022","500":"#F79009","600":"#DC6803","700":"#B54708","800":"#93370D","900":"#7A2E0E"},"gray":{"25":"#FCFCFC","50":"#FAFAFA","100":"#F1F1F1","200":"#E8E8E8","300":"#D6D6D6","400":"#A6A6A6","500":"#757575","600":"#575757","700":"#454545","800":"#2B2B2B","900":"#1C1C1C"},"red":{"25":"#FFFBFA","50":"#FEF3F2","100":"#FEE4E2","200":"#FECDCA","300":"#FDA29B","400":"#F97066","500":"#F04438","600":"#D92D20","700":"#B42318","800":"#912018","900":"#7A271A"},"orange":{"25":"#FFFCF5","50":"#FFFAEB","100":"#FEF0C7","200":"#FEDF89","300":"#FEC84B","400":"#FDB022","500":"#F79009","600":"#DC6803","700":"#B54708","800":"#93370D","900":"#7A2E0E"},"green":{"25":"#F6FEF9","50":"#ECFDF3","100":"#D1FADF","200":"#A6F4C5","300":"#6CE9A6","400":"#32D591","500":"#12B778","600":"#039861","700":"#027A52","800":"#056049","900":"#054F3E"},"blue":{"25":"#F5FBFF","50":"#F0FBFF","100":"#E0FAFE","200":"#B9F1FE","300":"#7CDFFD","400":"#36CFFA","500":"#0BB7EC","600":"#0097C9","700":"#0278A2","800":"#066486","900":"#0B536F"},"purple":{"25":"#F5F8FF","50":"#EEF4FF","100":"#E0EAFF","200":"#C7D7FE","300":"#A4BCFD","400":"#8098F9","500":"#6172F3","600":"#444CE7","700":"#3538CD","800":"#2D31A6","900":"#2D3282"}};